import { createSelector } from '@reduxjs/toolkit';

import { specialPromosBlocksSelector } from './specialPromosBlocksSelector';

export const developerFactsSelector = createSelector(specialPromosBlocksSelector, state => state.facts);
